import { queryKeys } from "../queryKeys";
import { getPositions, type Position } from "../rest/account";
import { useRequest } from ".";
import type { QueryOptions } from "./useRequest";

type UseGetPositionsArgs = {
  accountID?: string;
  product?: string;
  options?: QueryOptions<Position[]>;
};

export const useGetPositions = ({
  accountID,
  product,
  options = {},
}: UseGetPositionsArgs) => {
  const { data, ...rest } = useRequest(
    queryKeys.positions.list(accountID || "", product),
    () => getPositions({ accountID: accountID || "", product }),
    {
      ...options,
      // Suppress the shared error toast for this query.
      meta: { showErrorToast: false },
    },
  );

  return { positions: data || [], ...rest };
};

export default useGetPositions;
